import { registerPlugin, SystemBars, SystemBarsStyle } from "@capacitor/core";
import { isNativePlatform } from "./platform";

interface ThemePlugin {
  setDecorColor(options: { color: string }): Promise<void>;
}
const Theme = registerPlugin<ThemePlugin>("Theme");

// --background from style.css, as hex for the native side. Android's
// res/values*/colors.xml holds the same pair.
const LIGHT_BG = "#F9F8F6";
const DARK_BG = "#09090B";

export async function syncNativeTheme(isDark: boolean): Promise<void> {
  if (!isNativePlatform()) return;
  try {
    await Promise.all([
      SystemBars.setStyle({ style: isDark ? SystemBarsStyle.Dark : SystemBarsStyle.Light }),
      Theme.setDecorColor({ color: isDark ? DARK_BG : LIGHT_BG }),
    ]);
  } catch {
    // Plugin may not be available on all platforms
  }
}
